import React from 'react'
import Avatars from '../../../components/Avatars'
import {MdLocationPin} from 'react-icons/md'
import PillerImageBlue from '../assets/images/quiz_pillar_one.png'
import PillerImageOrange from '../assets/images/quiz_pillar_two.png'
import TrophyIcon from '../assets/images/trophy-icon.svg'
import StarIcon1 from '../assets/images/star-orange-1.png'
import StarIcon2 from '../assets/images/star-orange-2.png'
import StarIcon3 from '../assets/images/star-orange-3.png'
import DrawerBox from '../../../components/common/DrawerBox'
import {isMobile} from 'react-device-detect'

function LeaderBoardDrawer({open, setOpen, data}) {

    return data?.leaderBoardData?.length > 0 ? (
        <DrawerBox placement={isMobile ? 'bottom' : 'right'} headerStyle={{display: 'none'}}
                   bodyStyle={{padding: '16px'}} height={'90vh'} visible={open} setVisible={setOpen}>
            <div id='leaderboard-wrapper'>
                <div className='leaderboard-rank-container'>
                    <h1>LEADERBOARD</h1>
                    {data?.leaderBoardData?.length > 0 && (
                        <div className='flex fd-row jc-center pt-32 pl-32 pr-32'>
                            <div className='top-participation items-center relative' style={{marginRight: -16}}>
                                {data?.leaderBoardData?.length > 1 && (
                                    <div className='flex fd-column items-center jc-center relative'>
                                        <Avatars src={data?.leaderBoardData[1].profilePic}
                                                 alt={data?.leaderBoardData[1].name}/>
                                        <span
                                            className='top-participation-name mt-8 pl-20 pr-20'>{data?.leaderBoardData[1].name}</span>
                                        <div
                                            className='leader-position bg-blue font-size-12 font-color-white text-center width-16 height-16 rounded-full'>2
                                        </div>
                                    </div>
                                )}
                                <img src={PillerImageOrange} alt=''/>
                            </div>
                            <div className='top-participation'>
                                <div className='flex fd-column items-center jc-center relative'>
                                    <Avatars src={data?.leaderBoardData[0].profilePic}
                                             alt={data?.leaderBoardData[0].name}/>
                                    <img src={TrophyIcon} alt='' className='leader-position'/>
                                    <img src={StarIcon1} alt='' className='star-1'/>
                                    <img src={StarIcon2} alt='' className='star-2'/>
                                    <img src={StarIcon3} alt='' className='star-3'/>
                                    <span
                                        className='top-participation-name mt-8 pl-20 pr-20'>{data?.leaderBoardData[0].name}</span>
                                </div>
                                <img src={PillerImageBlue} alt=''/>
                            </div>
                            <div className='top-participation items-center relative' style={{marginLeft: -16}}>
                                {data?.leaderBoardData?.length > 2 && (
                                    <div className='flex fd-column items-center jc-center relative'>
                                        <Avatars src={data?.leaderBoardData[2].profilePic}
                                                 alt={data?.leaderBoardData[2].name}/>
                                        <span
                                            className='top-participation-name mt-8 pl-20 pr-20'>{data?.leaderBoardData[2].name}</span>
                                        <div
                                            className='leader-position bg-blue font-size-12 font-color-white text-center width-16 height-16 rounded-full'>3
                                        </div>
                                    </div>
                                )}
                                <img src={PillerImageOrange} alt=''/>
                            </div>
                        </div>
                    )}
                    {data?.currentUser && (
                        <div className='user-rank-container flex fd-row items-center'>
                            <Avatars src={data.currentUser.profilePic} name={data.currentUser.name}
                                     className='flex-shrink-0 mr-8'/>
                            <div
                                className='flex-grow-1 font-size-12 font-bold-500 font-color-white'>{data.currentUser.name}</div>
                            <div
                                className='flex fd-column align-flex-end flex-shrink-0 font-size-12 font-bold-500 font-color-white text-center default-line pr-24'>
                                <span>{data.position}</span>
                                <span>Rank</span>
                            </div>
                        </div>
                    )}
                </div>
                <div className='pl-16 pr-16 pb-16'>
                    <h3 className='font-size-16 font-bold-700 font-color-black text-center'>Participation List</h3>

                    <div className='participation-list-container'>
                        <div className='participation-list-card participation-list-header'>
                            <div>Rank</div>
                            <div>Total Correct Answered</div>
                        </div>
                        {data?.leaderBoardData?.length > 0 &&
                            data.leaderBoardData.map((items, index) => {
                                return (
                                    <div key={index} className='participation-list-card'>
                                        <div className='flex fd-row items-center'>
                                            <div
                                                className='flex-shrink-0 width-30 mr-8 font-size-18 font-bold-500 font-color-black'>#{index + 1}</div>
                                            <div className='flex fd-row items-center flex-grow-1'>
                                                <Avatars src={items.profilePic} name={items.name} className='mr-8'/>
                                                <div className='flex fd-row items-center'>
                                                    <div>
                                                        <h4 className='font-size-12 font-color-black'>
                                                            {items.name}
                                                            {items.userId === data?.currentUser?.userId && (
                                                                <span className='font-size-10 ml-4'
                                                                      style={{color: '#FBBF24'}}>
                                  (You)
                                </span>
                                                            )}
                                                        </h4>
                                                        {items.location && (
                                                            <p className='font-size-10 font-color-3'>
                                                                <MdLocationPin className='mr-2 opacity-8'/>
                                                                {items.location}
                                                            </p>
                                                        )}
                                                    </div>
                                                    {index === 0 && <img src={TrophyIcon} alt='' className='ml-8'/>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='font-size-12 font-bold-500 font-color-black'>
                                            <span className='font-size-16'>{items.totalCorrectQuestions}</span>
                                        </div>
                                    </div>
                                )
                            })}
                    </div>
                </div>
            </div>
        </DrawerBox>
    ) : ''
}

export default LeaderBoardDrawer
